export const isProd = true;
export const API_DOMAIN = isProd ? 'https://api.qdartdesign.com' : 'http://localhost:8080';